import {AncillaryDistributionListItem} from '../../../integrated-client/models/';

interface ITableData {
  records: Array<AncillaryDistributionListItem>
}

export class TableData implements ITableData{
  records: Array<AncillaryDistributionListItem>

  constructor() {
    this.records = [];
  }

}
